module.exports = __webpack_public_path__ + "static/media/calender1.4d821fed.svg";